import createSagaMiddleware from 'redux-saga';

import { configureStore } from '@reduxjs/toolkit';

import createRootReducer from './reducer';
import rootSaga from './sagas';

const reducer = createRootReducer();
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer,
  middleware: [sagaMiddleware],
});

window.store = store;
export default store;

sagaMiddleware.run(rootSaga);
